<template>
  <page-option :disable-add="!checkAccess('style.create')">
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-chart-line-variant</v-icon>
      </v-avatar>
      <div class="pl-2 title-page">
        {{ breadCrumb[breadCrumb.length - 1].name }}</div
      >
    </template>
    <template #below-toolbar>
      <FilterSearch
        canShowInSearch
        v-model="params"
        placeholder="Tìm kiếm theo tên"
        disable-create
        can-show-in-search
      >
        <v-spacer></v-spacer>
        <v-btn
          color="blue-grey"
          class="white--text mr-3 text-none"
          @click="onCreateIcon"
          text
        >
          Tải lên ký hiệu
          <v-icon right dark> mdi-cloud-upload </v-icon>
        </v-btn>
        <v-btn @click="onCreateFolder" text class="text-none">
          <v-icon left dark size="25"> mdi-folder-plus </v-icon>
          Tạo thư mục
        </v-btn>
      </FilterSearch>
    </template>
    <v-sheet class="overflow-auto">
      <div>
        <div class="d-flex mt-3">
          <v-btn fab outlined x-small class="mr-3" @click="goUpFolder">
            <v-icon size="30">mdi-arrow-left</v-icon>
          </v-btn>
          <div
            class="d-flex align-center"
            v-for="(link, index) in breadCrumb"
            :key="index"
          >
            <div
              class="pr-1"
              @click="goLinkId(link.id)"
              style="cursor: pointer; font-size: 16px"
              >{{ link.name }}</div
            >
            <div v-if="index < breadCrumb.length - 1" class="pl-1">
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </div>
        </div>
      </div>
      <base-serve-table
        ref="griddata"
        :api="api"
        :headers="[]"
        :defaultParams="default_params"
        :params="parentParam"
        use-grid
        use-scroll-load
        use-top
      >
        <template #grid-item="{ item }">
          <FolderItem
            v-if="item.type == 'icon-folder'"
            :value="item"
            @go-folder="goToFolderInfo"
            @delete-folder="onDeleteItem"
            @edit-folder="onUpdateItem"
          />
          <IconItem
            v-else-if="item.type == 'icon'"
            :value="item"
            @delete-icon="onDeleteItem"
            @edit-icon="onUpdateIcon"
          />
        </template>
      </base-serve-table>
    </v-sheet>

    <CreateFolderDialog ref="dialog" @reset="onReset" />
    <UploadIconDialog ref="dialogicon" @reset="onReset" />
    <UpdateIconDialog ref="dialogupdate" @reset="onReset" />
  </page-option>
</template>
<script>
import FilterSearch from '@layouts/filter-search.vue'
import { API_SYMBOL } from '@api'
import { ConfirmBuilder } from '@utils'
import { EDIT_TYPE } from '@constant'
import CreateFolderDialog from '../components/create-folder-dialog.vue'
import UpdateIconDialog from './dialog-update-icon.vue'
import UploadIconDialog from './dialog-upload-icon.vue'
import FolderItem from '../components/folder-item.vue'
import IconItem from '../components/icon-item.vue'

export default {
  components: {
    FilterSearch,
    CreateFolderDialog,
    UpdateIconDialog,
    UploadIconDialog,
    FolderItem,
    IconItem,
  },
  data: (vm) => ({
    workspace: {
      loading: false,
      items: [],
    },
    default_params: {},
    params: { search: '' },
    loading: false,
    breadCrumb: [{ id: null, name: 'Ký hiệu bản đồ' }],
  }),
  computed: {
    api() {
      return { list: API_SYMBOL.getFolderItems }
    },
    parentParam() {
      let param = { ...this.params }
      param.parent_id = this.$route.params.id
      param.type = 'icon'
      return param
    },
  },
  watch: {
    '$route.params.id': {
      handler: function(id) {
        this.getBreadCrumb(id)
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.getBreadCrumb(this.$route.params.id)
  },
  methods: {
    onCreateItem() {
      this.$refs.dialogcreatetype.open({}, EDIT_TYPE.CREATE)
    },
    onCreateFolder() {
      this.$refs.dialog.open({}, 'icon-folder', EDIT_TYPE.CREATE)
    },
    onCreateIcon() {
      this.$refs.dialogicon.open({}, EDIT_TYPE.CREATE)
    },
    onUpdateIcon(item) {
      this.$refs.dialogupdate.open(item)
    },
    onUpdateItem(item) {
      this.$refs.dialog.open(item, 'icon-folder', EDIT_TYPE.UPDATE)
    },
    onReset() {
      this.$refs.griddata.reload()
    },
    async onDeleteItem(id) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await API_SYMBOL.deleteIcon(id)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    goUpFolder() {
      if (this.breadCrumb.length > 1) {
        let folder = this.breadCrumb[this.breadCrumb.length - 2]
        if (folder.id == null) {
          this.$router.push('/ky-hieu-ban-do/symbol')
        } else this.$router.push('/ky-hieu-ban-do/folder-icon/' + folder.id)
      }
    },
    goToFolderInfo(id) {
      this.$router.push({ name: 'folderIcon', params: { id } })
    },
    async getBreadCrumb(folderID) {
      let data = await API_SYMBOL.getBreadCrumb(folderID)
      this.breadCrumb = [{ id: null, name: 'Ký hiệu bản đồ' }, ...data.data]
    },
    goLinkId(id) {
      if (id) {
        this.$router.push({ name: 'folderIcon', params: { id } })
      } else {
        this.$router.push('/ky-hieu-ban-do/symbol')
      }
    },
  },
}
</script>
<style scoped>
.image-box {
  height: 120px;
  width: 120px;
  border: 1px solid #d4e6f1;
}
</style>
